module.exports = __webpack_public_path__ + "static/media/money-bag-emoji.b5099d11.png";